// export default 'local'
// export default 'local'
// export default process.env.APP_ENV || 'local'
export default process.env.APP_ENV || 'development'



// WEBPACK FOOTER //
// ./src/mode.js